
import { Options, Vue } from "vue-class-component";
import { ElMessage, ElLoading } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";
import { User } from "@/script/apps/system/entity/SystemEntity";
import { ConfigService } from "@/script/apps/system/service/ConfigService";

@Options({})
export default class Login extends Vue {
  private user: User = { name: "admin", password: "" };  
  private rules = {
    name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
    password: [{ required: true, message: "请输入密码", trigger: "blur" }],
  };

  mounted() {
    this.$nextTick(() => {
      (this.$refs.password as any).focus();
    });    
  }

  login(formName: string) {
    const self = this;
    (this.$refs.formLogin as any).validate((valid: boolean) => {
      if (valid) {
        const loading = ElLoading.service({
          lock: true,
          text: "登录中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const userService = new UserService();
        userService.login(
          this.user,
          function (user: User) {
            loading.close();
            ElMessage.success("登录成功");
            self.$router.push({ path: "/" });
          },
          function (error: Error) {
            loading.close();
            ElMessage.error("登录失败，失败原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
